import { Component, OnInit } from '@angular/core';
import {TokenStorageService} from "../../services/storage/token-storage.service";

@Component({
    selector: 'app-configurations-page-main',
    templateUrl: './configurations-page-main.component.html',
    styleUrls: ['./configurations-page-main.component.css'],
    standalone: false
})
export class ConfigurationsPageMainComponent implements OnInit {
  showAdminComponents: boolean = false;
  showBrokerComponents: boolean = false;
  showBrokerAdminComponents:boolean=false;
  user: any;
  isLoggedIn: boolean = false;
  userInstitution :any;
  constructor(private tokenStorageService: TokenStorageService) { }

  ngOnInit(): void {
    this.isLoggedIn = !!this.tokenStorageService.getToken();
    if (this.isLoggedIn) {
      this.user = this.tokenStorageService.getUser();

      this.showAdminComponents = this.user.role == 'admin';
      this.showBrokerComponents = this.user.role == 'broker';
      this.showBrokerAdminComponents = this.user.role =='brokerAdmin';
    }
  }

  onButtonGroupClick($event: any) {
    let clickedElement = $event.target || $event.srcElement;

    if (clickedElement.nodeName === 'BUTTON') {
      let isCertainButtonAlreadyActive =
        clickedElement.parentElement.querySelector('.active');
      // if a Button already has Class: .active
      if (isCertainButtonAlreadyActive) {
        isCertainButtonAlreadyActive.classList.remove('active');
      }

      if ($event.target.className == 'nav-link view-container') {
        (<HTMLElement>(
          document.querySelector('.add-container-content')
        )).classList.remove('active');
        // (<HTMLElement>(
        //   document.querySelector('.bankAcc-content')
        // )).classList.remove('active');

        (<HTMLElement>(
          document.querySelector('.view-container-content')
        )).className += ' active';
        (<HTMLElement>(
          document.querySelector('.view-container-content')
        )).className += ' show';
      } else if ($event.target.className == 'nav-link add-container') {
        (<HTMLElement>(
          document.querySelector('.view-container-content')
        )).classList.remove('active');
        // (<HTMLElement>(
        //   document.querySelector('.bankAcc-content')
        // )).classList.remove('active');

        (<HTMLElement>(
          document.querySelector('.add-container-content')
        )).className += ' active';
        (<HTMLElement>(
          document.querySelector('.add-container-content')
        )).className += ' show';
      } else if ($event.target.className == 'nav-link bankAcc') {
        (<HTMLElement>(
          document.querySelector('.view-container-content')
        )).classList.remove('active');
        (<HTMLElement>(
          document.querySelector('.add-container-content')
        )).classList.remove('active');

        (<HTMLElement>document.querySelector('.bankAcc-content')).className +=
          ' active';
        (<HTMLElement>document.querySelector('.bankAcc-content')).className +=
          ' show';
      }

      clickedElement.className += ' active';
    }
  }

}
